import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import { Redirect, Switch, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import InternalHeader from 'app/layouts/InternalHeader';
import InBox from 'app/internalPages/InBox';
import LinesList from 'app/internalPages/Lines/pages/LinesList';
import LineDetails from 'app/internalPages/Lines/pages/LineDetails';
import PermissionariesList from 'app/internalPages/Lines/pages/PermissionariesList';
import PermissionariesDetails from 'app/internalPages/Lines/pages/PermissionariesDetails';
import ItinerariesList from 'app/internalPages/Lines/pages/ItinerariesList';
import FareList from 'app/internalPages/Lines/pages/FareList';
import TransferRequest from 'app/internalPages/Lines/pages/TransferRequest';
import RequestDetails from 'app/internalPages/RequestDetails';
import PrivateRoute from '../PrivateRoute';
import NewRequest from 'app/internalPages/NewRequest';
import Manuals from 'app/internalPages/Manuals';
import ItinerariesDetails from 'app/internalPages/Lines/pages/ItinerariesDetails';
import SchedulesDetails from 'app/internalPages/Lines/pages/SchedulesDetails';
import SchedulesList from 'app/internalPages/Lines/pages/SchedulesList';

import { INTERNAL_CONTEXT, URLS } from 'app/config/urls';
import { USERS_AUTHORITY } from 'app/utils/constants';
import ConductorsList from '../../../internalPages/Lines/pages/ConductorsList';
import ConductorsDetails from '../../../internalPages/Lines/pages/ConductorsDetails';
import ApostillesList from '../../../internalPages/Lines/pages/ApostillesList';
import ApostillesDetails from '../../../internalPages/Lines/pages/ApostillesDetails';
import ContractList from '../../../internalPages/Lines/pages/ContractList';
import ContractDetails from '../../../internalPages/Lines/pages/ContractDetails';
import ReportsContainer from '../../../internalPages/Reports/pages/ReportsContainer';
import Audit from '../../../internalPages/Audit';

function InternalRoutes(props) {
  useStyles();
  const { currentTheme, setCurrentTheme } = props;
  const user = useSelector(state => state.auth.user);
  const [hasAuthorities, setHasAuthorities] = useState(true);
  const [loadingAuthorities, setLoadingAuthorities] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (currentTheme !== 'internalPortal') {
      setCurrentTheme('internalPortal');
    }
  }, [currentTheme, setCurrentTheme]);

  useEffect(() => {
    const authorities = _.find(user.authorities, ['authority', USERS_AUTHORITY.interno]);
    if (!authorities) {
      setHasAuthorities(false);
    }
    setLoadingAuthorities(false);
  }, [user]);

  return (
    <>
      {!hasAuthorities && <Redirect to={URLS.WRONG} />}
      {!loadingAuthorities && (
        <>
          {location.pathname !== URLS.AUDIT && <InternalHeader />}
          <Switch>
            <PrivateRoute exact path={INTERNAL_CONTEXT} component={InBox} />
            <PrivateRoute exact path={URLS.INTERNAL_REQUEST_DETAILS} component={RequestDetails} />
            <PrivateRoute exact path={URLS.NEW_REQUEST} component={NewRequest} />
            <PrivateRoute exact path={URLS.MANUALS} component={Manuals} />
            <PrivateRoute exact path={URLS.LINES_MANAGE} component={LinesList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_NEW, URLS.LINES_MANAGE_EDIT]}
                          component={LineDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_PERMISSIONARIES} component={PermissionariesList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_PERMISSIONARIES_NEW, URLS.LINES_MANAGE_PERMISSIONARIES_EDIT]}
                          component={PermissionariesDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_ITINERARIES} component={ItinerariesList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_ITINERARIES_EDIT, URLS.LINES_MANAGE_ITINERARIES_NEW]}
                          component={ItinerariesDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_SCHEDULES} component={SchedulesList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_SCHEDULES_EDIT, URLS.LINES_MANAGE_SCHEDULES_NEW]}
                          component={SchedulesDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_CONDUCTORS} component={ConductorsList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_CONDUCTORS_EDIT, URLS.LINES_MANAGE_CONDUCTORS_NEW]}
                          component={ConductorsDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_APOSTILLE} component={ApostillesList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_APOSTILLE_EDIT, URLS.LINES_MANAGE_APOSTILLE_NEW]}
                          component={ApostillesDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_CONTRACT} component={ContractList} />
            <PrivateRoute exact path={[URLS.LINES_MANAGE_CONTRACT_EDIT, URLS.LINES_MANAGE_CONTRACT_NEW]}
                          component={ContractDetails} />

            <PrivateRoute exact path={URLS.LINES_MANAGE_FARES} component={FareList} />
            <PrivateRoute exact path={URLS.LINES_MANAGE_TRANSFERS} component={TransferRequest} />
            <PrivateRoute exact path={URLS.LINES_MANAGE_CONDUCTORS} component={ConductorsList} />
            <PrivateRoute exact path={URLS.LINES_MANAGE_CONDUCTORS_EDIT} component={ConductorsDetails} />
            <PrivateRoute exact path={URLS.LINES_MANAGE_CONDUCTORS_NEW} component={ConductorsDetails} />
            <PrivateRoute exact path={URLS.REPORTS} component={ReportsContainer} />
            <PrivateRoute exact path={URLS.AUDIT} component={Audit} />
          </Switch>
        </>
      )}
    </>
  );
}

const useStyles = makeStyles(() => ({
  '@global': {
    body: {
      background: `#eee top right no-repeat !important`,
    },
  },
}));

export default InternalRoutes;
